import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { Form } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";
import { useGetOptionExtraField } from "@src/hooks/ab-testing/use-get-option-extra-field";
import { BaseSelectExtraField } from "./base-select-extra-field";
import { generalStyleFormExtraItem } from "../modal-content";

export const MediaSource: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { isLoading, options } = useGetOptionExtraField({
    dimension: "media_source",
    fieldName: FilterFormFieldsEnum.EXTRA_MEDIA_SOURCE,
    form,
  });

  return (
    <Form.Item {...generalStyleFormExtraItem} name={FilterFormFieldsEnum.EXTRA_MEDIA_SOURCE} label="Media Source">
      <BaseSelectExtraField
        fieldName={FilterFormFieldsEnum.EXTRA_MEDIA_SOURCE}
        loading={isLoading}
        placeholder="Media Source"
        options={options}
      />
    </Form.Item>
  );
};
